import { render } from "./fullHorizontalScroll.vue?vue&type=template&id=38586f16&scoped=true&ts=true"
import script from "./fullHorizontalScroll.vue?vue&type=script&lang=ts"
export * from "./fullHorizontalScroll.vue?vue&type=script&lang=ts"

import "./fullHorizontalScroll.vue?vue&type=style&index=0&id=38586f16&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38586f16"]])

export default __exports__